export const listeners = {
    onUnauthorized: 'onUnauthorized',
    onAuthorized: 'onAuthorized',
};
